export default "__VITE_ASSET__DhCgmrOX__"